<template>
  <div class="main">
    <div class="pic">
      <img src="../assets/music163.png" alt=""/>
    </div>    
    <div class="content">
      <el-input v-model="address" placeholder="请输入网易云音乐的链接"></el-input>
      <el-button type="primary" @click="downloadmusic">下载</el-button>
    </div>
    <div class="toptip">
        <div class="tishi">操作提示：</div>
        <div class="tishitip">1.通过浏览器打开https://music.163.com/,您也可以点击 <el-link type="primary" href="https://music.163.com/" target="_blank">网易云音乐</el-link>打开，打开后搜索您想要下载的音乐</div>
        <div class="tishitip">2.打开您想下载的音乐</div>
        <div class="tishitip">3.复制该音乐的链接粘贴到上边的文本框，点击后边的下载按钮即可</div> 
        <div class="tishitip">4.链接的格式如下https://music.163.com/#/song?id=1989423797,id=前边是固定不变的，后边每个歌曲的ID不一样</div>   
    </div>
    <el-dialog title="请输入您获取到的验证码" :visible.sync="showcode" :width="showwidth" center>
            <p class="qqtext">请用手机微信扫描下方二维码，获取验证码</p>
            <div class="imgclass">
                <img class="qqimg" src="@/assets/code.png" alt="">
            </div>
            <el-input v-model="inputcode" maxlength="6" show-word-limit placeholder="请输入您获取到的验证码" clearable></el-input>
            <div slot="footer" class="dialog-footer">
                <el-button type="danger" @click="alipay">支付后直接下载</el-button>
                <el-button type="primary" @click="checkcode">确 定</el-button>
                <el-button @click="showcode = false">取 消</el-button>
            </div>
      </el-dialog>
      <el-dialog center :before-close="function(){}" :show-close="false" :destroy-on-close="true" :visible.sync="dialogTableVisible" style="width='680px'">
          <pay :img="qrimg" :money="0.1" paytype="alipay"></pay>
          <span slot="footer" class="dialog-footer">
            <el-button type="info" @click="paystatus" plain >已完成支付</el-button>
            <el-button type="info" @click="paystatus" plain >支付遇到问题</el-button>
          </span>
      </el-dialog>
  </div>
</template>

<script>
import pay from './pay.vue'
export default {
    name: "DbMusic",
    data(){
      return{
        address:"",

        showwidth: '80vw',
        inputcode:"",
        showcode:false,
        dialogTableVisible:false,       
        qrimg:"",
      }
    },
    components: {
        pay
    },
    methods:{
      paystatus(){
            this.dialogTableVisible=false
            this.$axios.post('/queryOrder',{out_trade_no:this.orderid}).then(res=>{
                if(res.data=='交易完成'){
                  let id = this.address.split("id=")[1].split("&")[0];
                  const a = document.createElement('a')
                  a.style.display = 'none'   
                  a.target='_blank'     
                  a.href = `http://music.163.com/song/media/outer/url?id=${id}.mp3`;      
                  a.click();                        
                  a.remove();  
                }                
            })
        },
        alipay(){
            this.showcode=false;        
            let data={
                money:0.1,
                subject:"网易云音乐下载"
            }
            this.$axios.post('/qrpayment',data)
            .then(res=>{
              console.log(res)
              this.qrimg=res.data.filename              
              this.dialogTableVisible=true
              this.orderid=res.data.out_trade_no       
            })
        },
        checkcode(){
            if (this.inputcode.length == 0) {
                this.$message({
                    message: '请输入您获取到的验证码',
                    type: 'warning'
                });
                return;
            }
            this.$axios({
                url: "/getcode",
                method: 'post',
                data: { code: this.inputcode,type:"网易云音乐下载"},
            }).then(res => {
                if(res.data=='OK'){
                    let id = this.address.split("id=")[1].split("&")[0];
                    const a = document.createElement('a')
                    a.style.display = 'none'   
                    a.target='_blank'     
                    a.href = `http://music.163.com/song/media/outer/url?id=${id}.mp3`;      
                    a.click();                        
                    a.remove();  
                } else if(res.data=='Wrong'){
                    this.$message({
                        message: '验证码错误',
                        type: 'warning'
                    });
                }else if(res.data=='Used'){
                    this.$message({
                        message: '该验证码已经被使用过了',
                        type: 'warning'
                    });
                }               
            })
        },
      downloadmusic(){
        if(this.address==null || this.address.length==0)
        {
            this.$message({
            message: '请输入网易云音乐的链接',
            type: 'warning'
            });
            return;
        }
        this.showcode=true
      }
     
    }
}
</script>

<style lang="less"  scoped>
  .main{
    
    .pic{
      height:90px;
      text-align: center;
      img{
        height: 100%;
      }
    }
    .content{
      margin: 30px auto;
      width: 70%;
      display: flex;
      justify-content: center;
      align-content: center;
    }

    .toptip{
        border: 1px solid #DEDEDE;
        border-left: 5px solid rgb(64,158,255);        
        padding-left: 10px;
        padding-right: 10px;
        padding-bottom: 10px;
        margin-top:10px;        
    }
    .tishi{
        font-size:18px;
        color:rgb(64,158,255);  
        line-height: 40px; 
        font-weight: bold;        
    }
    .tishitip{
        font-size:13px;  
        line-height: 25px;
        vertical-align:middle;
        span{
            color: #f00;
       }   
    }
    .qqtext {
            margin-bottom: 10px;
        }

        .imgclass {
            margin: 0 auto;
            width: 350px;
        }

        .qqimg {
            width: 100%;
        }
  }
  @media(max-width: 768px){
    .main{
      .pic{
        height:5vh;
      }
      .content{
        margin: 2vh auto;
        width: 90vw;
      }
      .qqtext {
        margin-bottom: 1vw;
        }

        .imgclass {
            margin: 0 auto;
            width: 50vw;
        }

        .qqimg {
            width: 100%;
        }
  }
}

</style>

<!-- 暗黑模式适配 -->
<style lang="less">
.dark-mode .main {
    .toptip {
        border-color: var(--border-color);
        border-left-color: #409eff;
    }
    .tishi { color: #409eff; }
    .tishitip { color: var(--text-regular); }
    .qqtext { color: var(--text-regular); }
}
</style>